
import { Vue } from "vue-class-component";

export default class Courier extends Vue {}
